export const ARCADE_PROJECT_STENCIL = 'arcades';
export const ROM_DESCRIPTION_KEY = 'rom.description';
export const ARCADE_PROJECT_KEY = [ 'arcade-ui', 'solution' ];
